import { CallOverrides } from "ethers";
      /* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type InteractionsContractFunctions1 =
  | []
  | [InteractionsContractFunctions]
  | [InteractionsContractFunctions, InteractionsContractEvents];
export type SWEvent = {
  event: InteractionsContractEventType;
  args: any;
}[];

export interface InteractionsContractFunctions {
  addInteraction: (
    activityID: number,
    member: string,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<InteractionsContractEvents>}>;
  daoExpander: (overrides?: CallOverrides) => Promise<string>;
  discordBotAddress: (overrides?: CallOverrides) => Promise<string>;
  /**
   * Response type names are:
   *
   * member: string
   * taskID: number
   * contractAddress: string
   */
  getInteraction: (interactionID: number, overrides?: CallOverrides) => Promise<[string, number, string]>;
  getInteractionsIndexPerAddress: (user: string, overrides?: CallOverrides) => Promise<number>;
}
export interface InteractionsContractEvents {
  events: SWEvent;
}

export enum InteractionsContractEventType {
  InteractionIndexIncreased = "InteractionIndexIncreased"
}
